import { createApiRef } from "@backstage/core-plugin-api";
import type { TemporalBackendClient } from "@internal/backstage-plugin-temporal-common";

/**
 * API reference for the Temporal backend client
 *
 * @public
 */
export const temporalApiRef = createApiRef<TemporalBackendClient>({
    id: "plugin.temporal.service",
});
